export const ICON_LIBRARIES = {
  lucide: {
    name: 'lucide-vue-next',
    package: 'lucide-vue-next',
    import: 'lucide-vue-next',
  },
  radix: {
    name: '@radix-icons/vue',
    package: '@radix-icons/vue',
    import: '@radix-icons/vue',
  },
}
